import { axios } from "@/plugins/axios";
import { AxiosPromise } from "axios";

export default {
  getPlacesDetail(id: any): AxiosPromise<Res<any>> {
    return axios({
      url: `https://chatluongnuocapi.cucthuyloi.gov.vn/api/place_datas/get-latest?searchFields=place_id:=&search=place_id:${id}&with=place&limit=100`,
      method: "get"
    });
  },
  getZones(): AxiosPromise<Res<any>> {
    return axios({
      url: `https://chatluongnuocapi.cucthuyloi.gov.vn/api/zones?searchJoin=AND&page=1&limit=50&with=places`,
      method: "get"
    });
  },
  getDataType(): AxiosPromise<Res<any>> {
    return axios({
      url: `https://chatluongnuocapi.cucthuyloi.gov.vn/api/data_types?limit=500`,
      method: "get"
    });
  },
  getPlacesDetailUseChart(id: any): AxiosPromise<Res<any>> {
    return axios({
      url: `https://chatluongnuocapi.cucthuyloi.gov.vn/api/place_datas?searchFields=place_id:=;data_type_id:=;data_value:=;imported_date:=;imported_date_from=;imported_date_to=&search=place_id:${id};data_type_id:;data_value:;imported_date_from:2000-01-01;imported_date_to:2025-08-25&limit=50000`,
      method: "get"
    });
  },
  getValueAllPlaceWithDataType(id: any): AxiosPromise<Res<any>> {
    return axios({
      url: `https://chatluongnuocapi.cucthuyloi.gov.vn/api/place_datas/get-latest?searchFields=place_id:=;data_type_id:=;data_value:=;imported_date:=;imported_date_from=;imported_date_to=&searchJoin=AND&with=dataType;place&search=data_type_id:${id}`,
      method: "get"
    });
  },
  searchPlaces(name: any): AxiosPromise<Res<any>> {
    return axios({
      url: `https://chatluongnuocapi.cucthuyloi.gov.vn/api/places?searchFields=name:like;zone_id:=&search=name:${name}&searchJoin=AND&with=zone&limit=200`,
      method: "get"
    });
  },
  getDischargeWaterPoints(zone_id: string): AxiosPromise<Res<any>> {
    return axios({
      url: `https://chatluongnuocapi.cucthuyloi.gov.vn/api/discharge_water?limit=100000&searchFields=zone_id:in&search=zone_id:${zone_id}`,
      method: "get"
    });
  },
  getDrains(zone_id: string): AxiosPromise<Res<any>> {
    return axios({
      url: `https://chatluongnuocapi.cucthuyloi.gov.vn/api/drain?limit=100000&searchFields=zone_id:in&search=zone_id:${zone_id}`,
      method: "get"
    });
  },
  getDams(zone_id: string): AxiosPromise<Res<any>> {
    return axios({
      url: `https://chatluongnuocapi.cucthuyloi.gov.vn/api/dam?limit=100000&searchFields=zone_id:in&search=zone_id:${zone_id}`,
      method: "get"
    });
  },
  getPumpStations(zone_id: string): AxiosPromise<Res<any>> {
    return axios({
      url: `https://chatluongnuocapi.cucthuyloi.gov.vn/api/pump_station?limit=100000&searchFields=zone_id:in&search=zone_id:${zone_id}`,
      method: "get"
    });
  }
};
